import React from "react";
import { applyTagsFilter, resetFilters } from "../../../Actions/Devices";
import Dialog from "./../../../Components/common/Dialog";
import MenuItem from "./../../../Components/common/MenuItem";
import TextField from "./../../../Components/common/TextField";
import Button from "./../../../Components/common/Button";
import Loader from "../../Loader";
import { connect } from "react-redux";
import instance from "../../../axios";

const defaultTagsList = {
  tag_1: [],
  tag_2: [],
  tag_3: [],
  tag_4: [],
  tag_5: [],
};

class VehicleTagSelector extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tag_1: "",
      tag_2: "",
      tag_3: "",
      tag_4: "",
      tag_5: "",
      tagsList: { ...defaultTagsList },
      tagsLoading: false,
    };
  }

  componentDidMount() {
    this.fetchVehicleTags();
  }

  fetchVehicleTags = () => {
    this.setState({ tagsLoading: true });
    instance(`/api/vehicles/tags`)
      .then((response) => {
        this.setState({
          tagsList: {
            tag_1: response?.tag_1 || [],
            tag_2: response?.tag_2 || [],
            tag_3: response?.tag_3 || [],
            tag_4: response?.tag_4 || [],
            tag_5: response?.tag_5 || [],
          },
          tagsLoading: false,
        });
      })
      .catch(() => {
        this.setState({ tagsLoading: false });
      });
  };

  onChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  cancelFilter = () => {
    this.props.cancelFilter();
  };
  saveFilter = () => {
    const filter = {
      tag_1: this.state.tag_1,
      tag_2: this.state.tag_2,
      tag_3: this.state.tag_3,
      tag_4: this.state.tag_4,
      tag_5: this.state.tag_5,
    };

    if (!filter.tag_1) delete filter.tag_1;
    if (!filter.tag_2) delete filter.tag_2;
    if (!filter.tag_3) delete filter.tag_3;
    if (!filter.tag_4) delete filter.tag_4;
    if (!filter.tag_5) delete filter.tag_5;
    const vehicles =
      this.props.vehicles &&
      this.props.vehicles.filter((item) => {
        for (var key in filter) {
          if (
            item.attributes[key] === undefined ||
            item.attributes[key] !== filter[key]
          )
            return false;
        }
        return true;
      });
    this.props.dispatch(resetFilters());
    if (vehicles && vehicles.length) {
      const list = vehicles.map((v) => v.deviceId);
      this.props.dispatch(applyTagsFilter(list));
    } else {
      this.props.dispatch(applyTagsFilter(["sxskaasd"]));
    }
    if (this.props.saveFilter) {
      this.props.saveFilter();
    }
    if (this.props.passToParent) {
      this.props.passToParent(filter);
    }
  };

  render() {
    const { vt1, vt2, vt3, vt4, vt5 } = this.props.userTags;
    const { tag_1, tag_2, tag_3, tag_4, tag_5 } = this.state.tagsList;
    const { translate, vehicleModal } = this.props;

    return vehicleModal ? (
      <Dialog
        visable
        onClose={this.cancelFilter}
        maxWidth="xs"
        title={this.props.translate("vehicleFilter")}
        isVisableBtn
        cancelText={this.props.translate("Cancel")}
        headerActions={
          <Button onClick={this.saveFilter} disabled={this.state.tagsLoading}>
            {this.props.translate("Save")}
          </Button>
        }
      >
        <div style={{ padding: 15, minHeight: 120 }}>
          {this.state.tagsLoading ? (
            <Loader defaultStyle imgSize={50} />
          ) : (
            <>
          <TextField
            fullWidth
            label={vt1 || translate("tag_1")}
            select
            onChange={(e) => this.onChange("tag_1", e.target.value)}
            value={this.state.tag_1}
          >
            <MenuItem value={""}></MenuItem>
            {tag_1 &&
              tag_1.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
          </TextField>
          <TextField
            fullWidth
            label={vt2 || translate("tag_2")}
            select
            onChange={(e) => this.onChange("tag_2", e.target.value)}
            value={this.state.tag_2}
          >
            <MenuItem value={""}></MenuItem>
            {tag_2 &&
              tag_2.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
          </TextField>
          <TextField
            fullWidth
            label={vt3 || translate("tag_3")}
            select
            onChange={(e) => this.onChange("tag_3", e.target.value)}
            value={this.state.tag_3}
          >
            <MenuItem value={""}></MenuItem>
            {tag_3 &&
              tag_3.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
          </TextField>
          <TextField
            fullWidth
            label={vt4 || translate("tag_4")}
            select
            onChange={(e) => this.onChange("tag_4", e.target.value)}
            value={this.state.tag_4}
          >
            <MenuItem value={""}></MenuItem>
            {tag_4 &&
              tag_4.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
          </TextField>
          <TextField
            fullWidth
            label={vt5 || translate("tag_5")}
            select
            onChange={(e) => this.onChange("tag_5", e.target.value)}
            value={this.state.tag_5}
          >
            <MenuItem value={""}></MenuItem>
            {tag_5 &&
              tag_5.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
          </TextField>
            </>
          )}
        </div>
      </Dialog>
    ) : null;
  }
}
const mapStateToProps = (state) => ({
  vehicles: state.vehicles,
});
export default connect(mapStateToProps)(VehicleTagSelector);
